import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { VelocityComponent } from 'velocity-react'
import styles from './HeroBrand.module.scss'

const diagonalOpacity = {
  animation: {
    opacity: 1
  }
}
const diagonalTiming = {
  duration: 900,
  delay: 700
}
const letterDuration = {
  duration: 900
}

class HeroBrand extends Component {
  constructor (props) {
    super(props)
    this.state = {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      show6: false,
      show7: false,
      show8: false,
      showBaseline: false
    }
  }

  componentDidMount () {
    const show1 = () => { this.setState({show1: true}) }
    const show2 = () => { this.setState({show2: true}) }
    const show3 = () => { this.setState({show3: true}) }
    const show4 = () => { this.setState({show4: true}) }
    const show5 = () => { this.setState({show5: true}) }
    const show6 = () => { this.setState({show6: true}) }
    const show7 = () => { this.setState({show7: true}) }
    const show8 = () => { this.setState({show8: true}) }
    const showBaseline = () => { this.setState({showBaseline: true}) }

    this.timer1 = setTimeout(() => { show1() }, 1650)
    this.timer2 = setTimeout(() => { show2() }, 1800)
    this.timer3 = setTimeout(() => { show3() }, 1950)
    this.timer4 = setTimeout(() => { show4() }, 2100)
    this.timer5 = setTimeout(() => { show5() }, 2200)
    this.timer6 = setTimeout(() => { show6() }, 2350)
    this.timer7 = setTimeout(() => { show7() }, 2400)
    this.timer8 = setTimeout(() => { show8() }, 2550)
    this.timer9 = setTimeout(() => { showBaseline() }, 3150)
  }

  componentWillUnmount () {
    if (this.timer1) clearTimeout(this.timer1)
    if (this.timer2) clearTimeout(this.timer2)
    if (this.timer3) clearTimeout(this.timer3)
    if (this.timer4) clearTimeout(this.timer4)
    if (this.timer5) clearTimeout(this.timer5)
    if (this.timer6) clearTimeout(this.timer6)
    if (this.timer7) clearTimeout(this.timer7)
    if (this.timer8) clearTimeout(this.timer8)
    if (this.timer9) clearTimeout(this.timer9)
  }

  render () {
    return (
      <div className={styles.wrap}>
        <div className={styles.container}>
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 151'>
            <VelocityComponent
              {...diagonalOpacity}
              {...diagonalTiming}
              runOnMount
            >
              <path id='diagonal1' className={`${styles.path} ${styles.hidden}`} d='M101.5 38.7l11 28.8h12.6l-11-28.8h-12.6z' />
            </VelocityComponent>
            <VelocityComponent
              {...diagonalOpacity}
              {...diagonalTiming}
              runOnMount
            >
              <path id='diagonal2' className={`${styles.path} ${styles.hidden}`} d='M155.7 1.1h12.5l25.4 66.3H181L155.7 1.1z' />
            </VelocityComponent>
            <VelocityComponent
              {...diagonalOpacity}
              {...diagonalTiming}
              runOnMount
            >
              <path id='diagonal3' className={`${styles.path} ${styles.hidden}`} d='M299.2 38.7l11 28.8h12.6l-11-28.8h-12.6z' />
            </VelocityComponent>
            <VelocityComponent
              animation={{opacity: this.state.show1 ? 1 : 0}}
              {...letterDuration}
            >
              <path id='letter1' className={`${styles.path} ${styles.hidden}`} d='M0 34.3C0 28.6.9 23.5 2.9 19c2-4.4 4.6-8 7.9-10.7C17.3 2.8 25.6 0 35 0c6.4 0 12.8 1.3 19.4 3.8l.5 4.8C48 4.3 41.6 2.2 35.4 2.2c-6.6 0-12.1 2.6-16.4 7.9-4.3 5.3-6.4 13.5-6.4 24.2s2.1 18.8 6.4 24.1c4.2 5.3 9.7 8 16.4 8 2.7 0 5.6-.4 8.5-1.2V39H32.6v-2.3h23.1v26.7C48.9 66.8 42 68.6 35 68.6c-13.7 0-26.4-6-32.1-19.1C.9 45.2 0 40 0 34.3z' />
            </VelocityComponent>
            <VelocityComponent
              animation={{opacity: this.state.show2 ? 1 : 0}}
              {...letterDuration}
            >
              <path id='letter2' className={`${styles.path} ${styles.hidden}`} d='M113 36.1c1.4-.6 2.6-1.4 3.8-2.2 4.5-3.3 6.7-8 6.7-14.2 0-12.4-9.2-18.4-22.7-18.4H74.3v66.4H86V38.8h13.7c.6 0 1.2 0 1.7-.1l11 28.8H125l-12-31.4zm-16.8.2H86.1V3.5h11c8.7 0 14.1 5.1 14.1 16.2-.1 11.1-6.1 16.6-15 16.6z' />
            </VelocityComponent>
            <VelocityComponent
              animation={{opacity: this.state.show3 ? 1 : 0}}
              {...letterDuration}
            >
              <path id='letter3' className={`${styles.path} ${styles.hidden}`} d='M168.3 1.1h-12.5l2.7 7-23.1 59.3h2.6l9.1-23.4h25.1l8.9 23.4h12.6L168.3 1.1zM148 41.8l11.7-30.2 11.6 30.2H148z' />
            </VelocityComponent>
            <VelocityComponent
              animation={{opacity: this.state.show4 ? 1 : 0}}
              {...letterDuration}
            >
              <path id='letter4' className={`${styles.path} ${styles.hidden}`} d='M204.5 1.1h11.8V47c0 10.7 6.3 17.4 16.6 17.4 11.6 0 18.2-7.2 18.2-19.8V1.1h2.5v43.5c0 15.7-9.2 24-24.1 24-7.4 0-13.5-2.1-18-6.1-4.7-4-7-9.9-7-17.7V1.1z' />
            </VelocityComponent>
            <VelocityComponent
              animation={{opacity: this.state.show5 ? 1 : 0}}
              {...letterDuration}
            >
              <path id='letter5' className={`${styles.path} ${styles.hidden}`} d='M310.7 36.1c1.4-.6 2.6-1.4 3.8-2.2 4.5-3.3 6.7-8 6.7-14.2 0-12.4-9.2-18.4-22.7-18.4H272v66.4h11.7V38.8h13.7c.6 0 1.2 0 1.7-.1l11 28.8h12.6l-12-31.4zm-16.8.2h-10.1V3.5h11c8.7 0 14.1 5.1 14.1 16.2-.1 11.1-6 16.6-15 16.6z' />
            </VelocityComponent>
            <VelocityComponent
              animation={{opacity: this.state.show6 ? 1 : 0}}
              {...letterDuration}
            >
              <path id='letter6' className={`${styles.path} ${styles.hidden}`} d='M394.7 15.6C385.6-.3 365.9-3.7 351.6 3.8c-4.9 2.5-8.9 6.4-12.1 11.8-3.2 5.3-4.8 11.6-4.8 18.7s1.6 13.3 4.8 18.6c9.1 16 28.8 19.4 43.2 11.9 4.8-2.5 8.8-6.5 12-11.9 3.2-5.3 4.8-11.5 4.8-18.6 0-7.1-1.6-13.4-4.8-18.7zm-13.6 42.3c-3.8 5.7-8.5 8.6-14 8.6s-10.1-2.9-13.9-8.6c-3.8-5.7-5.8-13.6-5.8-23.6 0-10 2-17.9 5.8-23.6 3.8-5.7 8.4-8.5 13.9-8.5s10.2 2.8 14 8.5c3.8 5.7 5.7 13.6 5.7 23.6 0 10-1.8 17.9-5.7 23.6z' />
            </VelocityComponent>
            <VelocityComponent
              animation={{opacity: this.state.show7 ? 1 : 0}}
              {...letterDuration}
            >
              <path id='letter7' className={`${styles.path} ${styles.hidden}`} d='M416.6 1.1h11.8v66.3h-11.8z' />
            </VelocityComponent>
            <VelocityComponent
              animation={{opacity: this.state.show8 ? 1 : 0}}
              {...letterDuration}
            >
              <path id='letter8' className={`${styles.path} ${styles.hidden}`} d='M444.3 34.3c0-5.7.9-10.8 2.9-15.3 2-4.4 4.6-8 7.9-10.7C461.6 2.9 470 .1 479.3.1c6.4 0 12.8 1.3 19.4 3.8l.5 4.8c-6.8-4.3-13.3-6.4-19.4-6.4-6.6 0-12.1 2.6-16.4 7.9-4.3 5.3-6.4 13.5-6.4 24.2s2.1 18.8 6.4 24.1c4.2 5.3 9.7 8 16.4 8 2.7 0 5.6-.4 8.5-1.2V39H477v-2.3h23v26.7c-6.8 3.5-13.7 5.2-20.7 5.2-13.7 0-26.4-6-32.1-19.1-2-4.3-2.9-9.5-2.9-15.2z' />
            </VelocityComponent>
            <VelocityComponent
              animation={{
                opacity: this.state.showBaseline ? 1 : 0,
                translateY: this.state.showBaseline ? ['0px', '3px'] : '3px'
              }}
              duration={700}
            >
              <g id='baseline' className={`${styles.baseline} ${styles.hidden}`}>
                <path className={styles.path} d='M146.758 97.499h5.195v14.53h2.606v-14.53h5.194v-2.364h-12.995V97.5ZM167.641 95.135h-2.606v16.894h2.606V95.135ZM181.797 94.8c-4.754 0-8.416 3.65-8.416 8.782s3.662 8.782 8.416 8.782c.212 0 .264 0 .652-.018a16.527 16.527 0 0 0 2.641 3.421l1.902-1.657c-.793-.723-1.515-1.552-2.008-2.346 3.082-1.252 5.212-4.267 5.212-8.182.018-5.149-3.645-8.782-8.399-8.782Zm0 15.201c-3.275 0-5.757-2.539-5.757-6.419 0-3.88 2.482-6.419 5.757-6.419 3.275 0 5.758 2.54 5.758 6.419 0 3.88-2.483 6.419-5.758 6.419ZM115.065 94.8c-4.754 0-8.399 3.65-8.399 8.782s3.663 8.782 8.399 8.782c4.754 0 8.416-3.65 8.416-8.782-.017-5.149-3.68-8.782-8.416-8.782Zm0 15.201c-3.275 0-5.758-2.539-5.758-6.419 0-3.88 2.483-6.419 5.758-6.419s5.758 2.54 5.758 6.419c0 3.88-2.483 6.419-5.758 6.419ZM139.152 105.945c0 2.363-1.461 4.056-3.979 4.056-2.501 0-3.98-1.693-3.98-4.056v-10.81h-2.605v10.881c0 4.073 2.764 6.348 6.585 6.348 3.803 0 6.585-2.275 6.585-6.348v-10.88h-2.606v10.809ZM98.849 102.877c1.373-.582 2.605-1.781 2.605-3.65 0-2.487-2.007-4.11-5.352-4.11h-6.55v16.894h6.655c3.205 0 5.952-1.887 5.952-5.025-.018-2.222-1.462-3.404-3.31-4.109Zm-6.691-5.467h3.75c1.884 0 3.028.67 3.028 2.275 0 1.587-1.162 2.275-3.028 2.275h-3.75v-4.55Zm3.768 12.344H92.14v-5.555h3.786c2.218 0 3.556.9 3.556 2.769.018 1.887-1.338 2.786-3.556 2.786ZM315.421 95.135h-2.589v16.894h11.058v-2.328h-8.469V95.135ZM205.884 105.945c0 2.363-1.461 4.056-3.979 4.056s-3.979-1.693-3.979-4.056v-10.81h-2.606v10.881c0 4.073 2.764 6.348 6.585 6.348 3.803 0 6.585-2.275 6.585-6.348v-10.88h-2.606v10.809ZM348.329 104.887l-1.972-1.111c-.246 1.287-.599 2.469-1.127 3.474l-3.451-4.567.07-.053c2.43-1.234 3.663-2.628 3.663-4.409 0-2.08-1.567-3.42-3.927-3.42-2.271 0-4.067 1.64-4.067 3.985 0 1.181.387 2.31 1.109 3.403-1.708 1.041-3.222 2.557-3.222 5.026 0 2.998 2.236 5.167 5.37 5.167a6.712 6.712 0 0 0 4.314-1.517l.898 1.182h2.87l-2.218-2.945c.774-1.235 1.338-2.681 1.69-4.215Zm-6.726-8.112c.898 0 1.761.582 1.761 1.57 0 1.129-.705 1.851-2.747 2.821-.634-.864-.898-1.622-.898-2.433.018-1.217.933-1.958 1.884-1.958Zm-.599 13.42c-1.743 0-3.151-1.199-3.151-3.033 0-1.464.774-2.487 1.972-3.333l3.979 5.308c-.775.67-1.708 1.058-2.8 1.058ZM386.872 95.135h-7.378v16.894h2.606v-6.137h4.772c3.68 0 6.074-2.01 6.074-5.378 0-3.368-2.394-5.379-6.074-5.379Zm-.106 8.447H382.1v-6.136h4.666c2.342 0 3.557 1.181 3.557 3.068s-1.215 3.068-3.557 3.068ZM401.099 95.135l-6.744 16.894h2.747l1.813-4.708h6.991l1.813 4.708h2.747l-6.744-16.894h-2.623Zm-1.321 9.911 2.043-5.326c.334-.864.581-1.622.581-1.622s.246.74.581 1.622l2.042 5.326h-5.247ZM368.613 102.224c-2.958-.582-4.402-1.446-4.402-2.962 0-1.446 1.514-2.204 3.293-2.204 2.095 0 3.521 1.11 4.19 3.138l2.078-1.199c-.933-2.68-3.205-4.197-6.233-4.197-3.398 0-5.775 1.834-5.775 4.515 0 2.839 2.289 4.373 5.423 4.973 2.887.546 4.296 1.322 4.296 3.085 0 1.499-1.356 2.734-3.592 2.734-2.553 0-4.12-1.464-4.596-4.25l-2.289 1.181c.546 3.016 2.888 5.326 6.92 5.326 3.803 0 6.163-2.363 6.163-5.096-.035-2.822-1.831-4.338-5.476-5.044ZM216.924 104.446h7.8v-2.31h-7.8v-4.69h8.47v-2.31h-11.076v16.893h11.146v-2.328h-8.54v-5.255ZM250.836 102.224h-7.853v-7.089h-2.605v16.894h2.605v-7.442h7.853v7.442h2.589V95.135h-2.589v7.089ZM267.106 94.8c-4.754 0-8.417 3.65-8.417 8.782s3.663 8.782 8.417 8.782 8.398-3.65 8.398-8.782c.018-5.149-3.644-8.782-8.398-8.782Zm0 15.201c-3.275 0-5.758-2.539-5.758-6.419 0-3.88 2.483-6.419 5.758-6.419s5.757 2.54 5.757 6.419c0 3.88-2.465 6.419-5.757 6.419ZM298.834 104.446h7.8v-2.31h-7.8v-4.69h8.487v-2.31h-11.093v16.893h11.164v-2.328h-8.558v-5.255ZM278.427 97.499h5.212v14.53h2.606v-14.53h5.194v-2.364h-13.012V97.5Z' />
                <g className={styles.path}>
                  <path d="M156.126 130.033L158.732 138.039H167.13L160.334 142.994L162.922 151L156.126 146.045L149.329 151L151.917 142.994L145.121 138.039H153.52L156.126 130.033Z"/>
                  <path d="M204.229 130.033L206.835 138.039H215.234L208.438 142.994L211.026 151L204.229 146.045L197.433 151L200.021 142.994L193.225 138.039H201.641L204.229 130.033Z"/>
                  <path d="M252.333 130.033L254.939 138.039H263.338L256.541 142.994L259.129 151L252.333 146.045L245.536 151L248.125 142.994L241.328 138.039H249.745L252.333 130.033Z"/>
                  <path d="M300.437 130.033L303.043 138.039H311.441L304.645 142.994L307.251 151L300.437 146.045L293.64 151L296.246 142.994L289.432 138.039H297.848L300.437 130.033Z"/>
                  <path d="M348.54 130.033L351.146 138.039H359.545L352.749 142.994L355.354 151L348.54 146.045L341.744 151L344.35 142.994L337.536 138.039H345.952L348.54 130.033Z"/>
                </g>
              </g>
            </VelocityComponent>
          </svg>
        </div>
      </div>
    )
  }
}

HeroBrand.propTypes = {

}

export default HeroBrand
